import { useState, useEffect } from "react";
import { formatDateShort } from "../../lib/format";
import { CountdownTimer } from "../CountdownTimer";
import { useLang } from "../../context/LanguageContext";

export function StickyBar({ course, onInfo, onEnroll }) {
  const { t, lang } = useLang();
  const [show, setShow] = useState(false);

  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 560);
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <div
      data-testid="sticky-bar"
      className={`fixed top-0 left-0 w-full z-40 backdrop-blur-xl bg-[#0B1220]/85 border-b border-white/10 shadow-lg transition-transform duration-300 ${
        show ? "translate-y-0" : "-translate-y-full"
      }`}
    >
      <div className="px-6 md:px-12 max-w-[1400px] mx-auto py-3 flex items-center justify-between gap-4 text-white">
        <div className="hidden md:flex items-center gap-6 min-w-0">
          <div className="flex flex-col leading-tight">
            <span className="text-[10px] uppercase tracking-[0.18em] text-[#5B9DFF]">{t("sticky.date")}</span>
            <span className="text-sm font-medium text-white">{formatDateShort(course.date_time, lang)}</span>
          </div>
          <div className="h-8 w-px bg-white/15" />
          <div className="flex flex-col leading-tight">
            <span className="text-[10px] uppercase tracking-[0.18em] text-[#5B9DFF]">{t("sticky.price")}</span>
            <span className="text-sm font-medium text-white">{course.price}</span>
          </div>
          <div className="h-8 w-px bg-white/15" />
          <div className="flex flex-col leading-tight">
            <span className="text-[10px] uppercase tracking-[0.18em] text-[#FF6B6B]">{t("sticky.limited")}</span>
            <span className="text-white"><CountdownTimer date={course.date_time} variant="sticky" light testid="sticky-countdown" /></span>
          </div>
        </div>
        <div className="md:hidden flex flex-col leading-tight">
          <span className="text-sm font-medium text-white truncate max-w-[160px]">{course.price}</span>
          <span className="text-white"><CountdownTimer date={course.date_time} variant="sticky" light testid="sticky-countdown-mobile" /></span>
        </div>

        <div className="flex items-center gap-2 shrink-0">
          <button
            data-testid="sticky-info-btn"
            onClick={onInfo}
            className="bg-[#1452F0] text-white hover:bg-[#0E3DC0] transition-colors rounded-sm px-4 md:px-6 py-2.5 text-xs md:text-sm font-medium tracking-wide whitespace-nowrap shadow-[0_0_20px_rgba(20,82,240,0.5)]"
          >
            {t("common.request_info")}
          </button>
          <button
            data-testid="sticky-enroll-btn"
            onClick={onEnroll}
            className="border border-white/30 text-white hover:bg-white hover:text-[#0B1220] transition-colors rounded-sm px-4 md:px-6 py-2.5 text-xs md:text-sm font-medium tracking-wide whitespace-nowrap"
          >
            {t("common.enroll_online")}
          </button>
        </div>
      </div>
    </div>
  );
}
